// log the pageview with their URL
export const pageview = (url: string) => {
  if ((window as any).gtag) {
    (window as any).gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      page_path: url,
    })
  } else {
    console.error('fail to create GA page_view')
  }
}

interface GAParams {
  search_term: string

  [key: string]: string
}

// log specific events happening.
export const event = ({action, params}: { action: string, params: GAParams }) => {
  (window as any).gtag('event', action, params)
}

export const useGoogleAnalytics = () => {
  return {
    event,
    pageview
  }
}